import React, { PureComponent } from 'react'

import UseAccount from '@connects/account'
import UseCounts from '@connects/counts'
import combine from '@connects/combine'

import Loading from '@components/Loading/Loading'

const dashboardContainer = (Dashboard) => {


	@combine({
		account: UseAccount(),
		counts: UseCounts(),
	})
  class DashboardContainer extends PureComponent {

    componentDidMount() {}

    render() {
    	const { counts, account } = this.props;
      return account.data && counts.countData
     		? <Dashboard {...this.props} />
     		: <Loading />;
    }

  }

  return DashboardContainer;

}

export default dashboardContainer;


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/DashboardContainer.jsx